<div class="legend-container" *ngIf="appService.theme$ | async as theme">
    <div class="content">
      <h4>Flights/Sequences</h4>
      <p class="note">The sequences and legs on Table View for the month and year selected 
        includes sequences and legs in the contractual month for which the sequence began.</p>
        <div class="button-container">
          <p-button 
            [dt]="moreInfoButton" 
            (click)="moreInfo()"
            [style]="{'width': '100%'}"
            >
            See Contractual Months
          </p-button>
        </div>
    </div>
    <hr />
    <div class="content">
      <div class="container">
        <h4>Sort/Filter Quick Reference</h4>
        <div class="icon-row">
          <i class="sort-icon pi pi-arrow-up"></i>
          <div class="flt-icon">F</div>
          <div class="inactive-icon">D</div>
          <div class="cx-icon">C</div>
        </div>
      </div>
      <ul>
        <li>
          <div class="info-row">
            <i class="sort-icon pi pi-arrow-up"></i>
            <span class="item-content">Sorting direction</span>
          </div>
        </li>
        <li>
          <div class="info-row">
            <div class="flt-icon">F</div>
            <span class="item-content">Selcted item included</span>
          </div>
        </li>
        <li>
          <div class="info-row">
            <div class="inactive-icon">F</div>
            <span class="item-content">Selected item omitted</span>
          </div>
        </li>
      </ul>
    </div>
    <hr />
    <div class="content">
      <div class="container">
        <h4>Refresh Flights</h4>
      </div>
      <ul>
        <li>
          <div class="info-row">
            <div class="pi pi-sync sync-icon"></div>
            <span class="item-content">Press to Refresh Flights</span>
          </div>
        </li>
      </ul>
    </div>
    <hr />
    <div class="container">
      <h4>Flight Item Legend</h4>
    </div>
     <img class="legend-image"
        [src]="theme === 'light' ? 'assets/flightItemLegend_Light.png' : 'assets/flightItemLegend_Dark.png'"
        alt="Flight Item"
        [style]="{'padding-top': '10px'}"
        />
        <ol>
          <li *ngFor="let item of legendItems; let i = index">
            <div class="item-content">{{item}}</div>
          </li>
        </ol>
</div>
